import PWAInstructionLogo from './PWAInstructionLogo';

export default PWAInstructionLogo;
